import { privateApi } from 'services';
import { BusinessAccountLinkedinSettingsItem } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const createBusinessAccountLinkedinSettingsItem = (
    businessAccountLinkedinSettings: BusinessAccountLinkedinSettingsItem,
): Promise<BusinessAccountLinkedinSettingsItem> =>
    privateApi.post<BusinessAccountLinkedinSettingsItem>(
        'business-account-linkedin-settings',
        businessAccountLinkedinSettings,
    );

const updateBusinessAccountLinkedinSettingsItem = (
    businessAccountId: string,
    settings: {
        channelEnabled: boolean;
    },
): Promise<BusinessAccountLinkedinSettingsItem> =>
    privateApi.put<BusinessAccountLinkedinSettingsItem>(
        `business-account-linkedin-settings/${businessAccountId}`,
        settings,
    );

export const BusinessAccountLinkedinSettingsItemGateway = {
    createBusinessAccountLinkedinSettingsItem,
    updateBusinessAccountLinkedinSettingsItem,
};

const cancelableFetchBusinessAccountLinkedinSettingsItem = (
    businessAccountId: string,
): Promise<BusinessAccountLinkedinSettingsItem> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BusinessAccountLinkedinSettingsItem>(
        `business-account-linkedin-settings/${businessAccountId}`,
    );

export const CancelableBusinessAccountLinkedinSettingsItemGateway = {
    cancelableFetchBusinessAccountLinkedinSettingsItem,
};
